import { useState } from "react";
// 1. IMPORT KATEX CSS AND COMPONENT
import FormattedText from "./FormattedText";

import { 
  startRecording, 
  stopRecording, 
  pauseRecording, 
  resumeRecording, 
  restartRecording 
} from '../../Utility/audioService';

const SingleQuestionRecorder = ({ question }) => {
  const [status, setStatus] = useState("idle"); 
  const [audioUrl, setAudioUrl] = useState(null);

  // --- NEW: PATTERN DETECTION LOGIC ---

  const handleStart = async () => {
    const res = await startRecording(question.id);
    if (!res?.error) setStatus("recording");
  };

  const handleStop = async () => {
    const { url } = await stopRecording(question.id);
    setAudioUrl(url);
    setStatus("saved");
  };

  const handlePause = () => {
    pauseRecording(question.id);
    setStatus("paused");
  };

  const handleResume = () => {
    resumeRecording(question.id);
    setStatus("recording");
  };

  const handleRestart = async () => {
    if (window.confirm("Restarting will wipe the current recording. Continue?")) {
      await restartRecording(question.id);
      setStatus("recording");
    }
  };

  return (
    <div className="border border-gray-300 p-6 rounded-lg bg-white shadow-sm max-w-3xl mx-auto">
      
      {/* 3. FORMATTED TEXT RENDERER */}
      <div className="mb-6 font-medium text-lg">
        <FormattedText text={question.text} />
      </div>

      {/* Optional Image */}
      {question.image_src && question.image_src.trim() !== "" && (
        <div className="mb-6">
          <img
            src={question.image_src}
            alt="Question reference"
            className="max-w-md h-auto rounded-md border border-gray-200"
          />
        </div>
      )}

      <div className="text-xs text-gray-400 mb-4 font-mono">ID: {question.id}</div>

      <div className="flex flex-wrap items-center gap-3">
        {/* Buttons (Same as before) */}
        {status === "idle" && (
          <button
            onClick={handleStart}
            className="bg-blue-600 text-white px-5 py-2.5 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Start Recording
          </button>
        )}

        {status === "recording" && (
          <>
            <span className="text-red-600 animate-pulse font-bold flex items-center gap-2">
               <span className="h-3 w-3 bg-red-600 rounded-full"></span> Recording...
            </span>

            <button onClick={handlePause} className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1.5 rounded-lg text-sm transition-colors">
              Pause
            </button>

            <button onClick={handleStop} className="bg-red-600 hover:bg-red-700 text-white px-3 py-1.5 rounded-lg text-sm transition-colors">
              Stop & Save
            </button>

            <button onClick={handleRestart} className="text-gray-500 hover:text-gray-700 underline text-sm ml-2">
              Restart
            </button>
          </>
        )}

        {status === "paused" && (
          <>
            <span className="text-yellow-600 font-bold">⏸ Paused</span>
            <button onClick={handleResume} className="bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded-lg text-sm">
              Resume
            </button>
            <button onClick={handleStop} className="bg-red-600 hover:bg-red-700 text-white px-3 py-1.5 rounded-lg text-sm">
              Stop & Save
            </button>
          </>
        )}

        {status === "saved" && (
          <div className="flex items-center gap-4 w-full mt-2 bg-green-50 p-3 rounded-md border border-green-100">
            <span className="text-green-700 font-bold flex items-center gap-2">
               ✓ Saved
            </span>
            {audioUrl && (
              <audio controls src={audioUrl} className="h-8 w-64" />
            )}
            <button onClick={handleStart} className="ml-auto text-red-600 font-semibold text-sm hover:underline">
              Record Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleQuestionRecorder;